/**
 * Initialize any VideoJazz elements on the page
 *
 * Your VideoJazz element should look like this:
 *
 * .videojazz[data-videojazz-url="URL"]
 *   .videojazz__back
 *   .videojazz__front
 *     -- Put whatever you want in here --
 *     (optional) .videojazz__play
 *     (optional) .videojazz__close
 */
export function initVideoJazz() {
	const $vj = $('[data-videojazz]').once('initVideoJazz')
	let deps = Promise.reject()
	if ($vj.length) {
		deps = Promise.all([
			import('../onTapped'),
			import('../vJazzle')
		])
	}
	deps.then(([{onTapped}, {vJazzle}]) => {
		$vj.each(function () {
			const $this = $(this)

			const url = $this.data('videojazzUrl')
			if (!url) {
				$this.hide()
				console.error('A VideoJazz element was not given a URL! Please set a VideoJazz URL on', this)
				return
			}

			const $back = $('.videojazz__back', $this)
			if (!$back.length) {
				$this.hide()
				console.error('A VideoJazz element does not have a `.videojazz__back`, and so has no place to put a video. Please add a `.videojazz__back` to', this)
				return
			}

			const vj = vJazzle({
				element: $back,
				videoUrl: $this.data('videojazzUrl')
			})

			const $front = $('.videojazz__front', $this)
			if ($front.length) {
				onTapped($front, vj.play)
			}

			// TODO Change the state to the current state of the player?
			const active = () => $this.attr('data-state', 'active')
			const inactive = () => $this.attr('data-state', '')

			vj.on('aboutToPlay', active)
			vj.on('play', active)
			vj.on('pause', inactive)
			vj.on('end', inactive)

			$this.removeClass('js-not-yet')
		})
	}).catch(() => {
	})
}